import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getYear = createAsyncThunk('/group/getYear',
    async (group) => {
        try {
            const myurl = `${PAY_URL}/admin/get-year`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN')
                },
            });

            const data = response.data;
            // console.log(data, "getYear response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getYearSlice = createSlice({
    name: "getYear",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getYear.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getYear.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getYear.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getYearSlice.reducer;